import { assertEvent, assign } from 'xstate';

import { type BundleMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Drops one product from the bundle.
 */
export const removeSelectedProduct: BundleMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'REMOVE_SELECTED');

  return {
    selectedProducts: context.selectedProducts.filter(
      (selectedProduct) => selectedProduct.selectionId !== event.selectionId,
    ),
  };
});
